module.exports = {
	"_args": [
		[
			{
				"raw": "doctrine@^1.4.0",
				"scope": null,
				"escapedName": "doctrine",
				"name": "doctrine",
				"rawSpec": "^1.4.0",
				"spec": ">=1.4.0 <2.0.0",
				"type": "range"
			},
			"/Users/Jade/Code/Github/material-ui/docs"
		]
	],
	"_from": "doctrine@>=1.4.0 <2.0.0",
	"_id": "doctrine@1.4.0",
	"_inCache": true,
	"_installable": true,
	"_location": "/doctrine",
	"_nodeVersion": "4.4.7",
	"_npmOperationalInternal": {
		"host": "packages-12-west.internal.npmjs.com",
		"tmp": "tmp/doctrine-1.4.0.tgz_1473795937747_0.04119571251794696"
	},
	"_npmUser": {
		"name": "eslint",
		"email": "nicholas+eslint@nczconsulting.com"
	},
	"_npmVersion": "2.15.8",
	"_phantomChildren": {},
	"_requested": {
		"raw": "doctrine@^1.4.0",
		"scope": null,
		"escapedName": "doctrine",
		"name": "doctrine",
		"rawSpec": "^1.4.0",
		"spec": ">=1.4.0 <2.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"#DEV:/",
		"/eslint",
		"/eslint-plugin-react",
		"/react-docgen"
	],
	"_resolved": "https://registry.npmjs.org/doctrine/-/doctrine-1.4.0.tgz",
	"_shasum": "e2db32defa752407b935b381e89f3740e469e599",
	"_shrinkwrap": null,
	"_spec": "doctrine@^1.4.0",
	"_where": "/Users/Jade/Code/Github/material-ui/docs",
	"bugs": {
		"url": "https://github.com/eslint/doctrine/issues"
	},
	"dependencies": {
		"esutils": "^2.0.2",
		"isarray": "^1.0.0"
	},
	"description": "JSDoc parser",
	"devDependencies": {
		"coveralls": "^2.11.2",
		"dateformat": "^1.0.11",
		"eslint": "^1.10.3",
		"eslint-release": "^0.10.0",
		"istanbul": "^0.4.1",
		"linefix": "^0.1.1",
		"mocha": "^2.3.3",
		"npm-license": "^0.3.1",
		"semver": "^5.0.3",
		"shelljs": "^0.5.3",
		"shelljs-nodecli": "^0.1.1",
		"should": "^5.0.1"
	},
	"directories": {
		"lib": "./lib"
	},
	"dist": {
		"shasum": "e2db32defa752407b935b381e89f3740e469e599",
		"tarball": "https://registry.npmjs.org/doctrine/-/doctrine-1.4.0.tgz"
	},
	"engines": {
		"node": ">=0.10.0"
	},
	"files": [
		"lib",
		"LICENSE.BSD",
		"LICENSE.closure-compiler",
		"LICENSE.esprima",
		"README.md"
	],
	"gitHead": "39e5f75775ef84ceabdb07683dd68de318bc3571",
	"homepage": "https://github.com/eslint/doctrine",
	"licenses": [
		{
			"type": "BSD",
			"url": "http://github.com/eslint/doctrine/raw/master/LICENSE.BSD"
		}
	],
	"main": "lib/doctrine.js",
	"maintainers": [
		{
			"name": "constellation",
			"email": "utatane.tea@gmail.com"
		},
		{
			"name": "eslint",
			"email": "nicholas+eslint@nczconsulting.com"
		},
		{
			"name": "nzakas",
			"email": "nicholas@nczconsulting.com"
		}
	],
	"name": "doctrine",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/eslint/doctrine.git"
	},
	"scripts": {
		"alpharelease": "eslint-prerelease alpha",
		"betarelease": "eslint-prerelease beta",
		"ci-release": "eslint-ci-release",
		"lint": "eslint lib/",
		"release": "eslint-release",
		"test": "npm run lint && node Makefile.js test"
	},
	"version": "1.4.0"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/doctrine/package.json
 ** module id = 925
 ** module chunks = 0
 **/